// @types/combokeys doesn't have definitions for the global-bind plugin.
// This file is a workaround.

// eslint-disable-next-line
// @ts-ignore
import Combokeys from 'combokeys';

// eslint-disable-next-line
// @ts-ignore
import bindGlobalPlugin from 'combokeys/plugins/global-bind';

export type CombokeysWithGlobalBind<T extends Combokeys.Combokeys = Combokeys.Combokeys> = T & {
  /**
   * binds an event to Combokeys which will fire, even if in a form element.
   *
   * can be a single key, a combination of keys separated with +,
   * an array of keys, or a sequence of keys separated by spaces
   *
   * be sure to list the modifier keys first to make sure that the
   * correct key ends up getting bound (the last key in the pattern)
   *
   * @param {keys} key combination or combinations
   * @param {callback} callback function
   * @param {handler} optional - one of "keypress", "keydown", or "keyup"
   * @returns void
   */
  bindGlobal(
    keys: string | string[],
    callback: (event: KeyboardEvent) => void,
    action?: string,
  ): void;
};

export function createCombokeys(element: Element) {
  const combokeys = new Combokeys(element);
  const withGlobalPlugin: CombokeysWithGlobalBind = bindGlobalPlugin(combokeys);
  return withGlobalPlugin;
}
